import {React, useState} from 'react';
import Axios from "axios";
import { FaSearch } from "react-icons/fa";
import { FcSpeaker } from "react-icons/fc";
import {Link} from 'react-router-dom'

function Dic(){
    
    const [data, setData] = useState("");
    const [searchWord, setSearchWord] = useState("");
    
    function getMeaning() {
        Axios.get(
          `https://api.dictionaryapi.dev/api/v2/entries/en_US/${searchWord}`
        ).then((response) => {
          setData(response.data[0]);
        });
      }

      function playAudio() {
        let audio = new Audio(data.phonetics[0].audio);
        audio.play();
      }
    
     return (
        

    <div className="App">
        <nav aria-label="breadcrumb" className='mt-2'>
  <ol className="breadcrumb text-dark ">
    <li className="breadcrumb-item "><Link to="/">Home</Link></li>
    <li className="breadcrumb-item active" aria-current="page">DDAI Dictionary</li>
  </ol>
</nav>
        <div className='dic'>
        <div className="card p-5 ">
      <h2><b>DDAI</b> Dictionary</h2>
      <div className="card-body">
      <div className="searchBox">
 
      <br/> 
        <input
          type="text"
          placeholder="Search for any word..."
          onChange={(e) => {
            setSearchWord(e.target.value);
          }}
        />
         <br/> <br/>
        <button className="btn btn-warning"
          onClick={() => {
            getMeaning();
          }}
        >
          <FaSearch size="20px" color="black"  />
        </button>
      </div>
      {data && (
        <div className="showResults">
          <h2>
            {data.word}{" "}
            <button
              onClick={() => {
                playAudio();
              }}
            >
              <FcSpeaker size="26px" />
            </button>
          </h2>
          <h4>Parts of speech:</h4>
 
           
<p>{data.meanings[0].partOfSpeech}</p>
 
 
          <h4>Definition:</h4>
 
           
<p>{data.meanings[0].definitions[0].definition}</p>
 
 
          <h4>Example:</h4>
 
           
<p>{data.meanings[0].definitions[0].example}</p>
 
        </div>
        
      )}
    </div>
    </div>
  
    </div>
    </div>
  );
}

export default Dic